"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MESSAGE_NOT_SHOWN_MESSAGE = void 0;
exports.anchorLiveReviewTimerStart = anchorLiveReviewTimerStart;
exports.firstMessage = exports.convertToExtendedMessage = void 0;
exports.useMessageList = useMessageList;
var _DocumentCitationAnchor = require("../../components/chat/DocumentCitationAnchor");
var _MessageItem = _interopRequireDefault(require("../../components/chat/MessageItem"));
var _SectionBoundary = require("../../components/SectionBoundary");
var _hoverTooltip = require("@common/components/hover-tooltip");
var _chat = require("../../types/chat");
var _chatCitations = require("../../utils/chat-citations");
var _document = require("../../utils/document");
var _documentBackupPlacement = require("../../utils/document-backup-placement");
var _openInBrowserWindow = require("../../utils/open-in-browser-window");
var _toast = require("../../utils/toast");
var _webApi = require("../../utils/web-api");
var _AddinArtifactThumbnail = require("../../components/chat/AddinArtifactThumbnail");
var _ScrollToFormLink = require("@common/components/ScrollToFormLink");
var _ChatAnchorRouter = require("@common/components/chat/ChatAnchorRouter");
var _groupAssistantSteps = require("@common/components/chat/groupAssistantSteps");
var _rateableMessages = require("@common/components/chat/rateableMessages");
var _tools = require("@common/constants/tools");
var _sharedChatTableComponents = require("@common/markdown/sharedChatTableComponents");
var _sharedMarkdownComponents = require("@common/markdown/sharedMarkdownComponents");
var _chatMarkdownPipeline = require("@common/markdown/chatMarkdownPipeline");
var _chatMessageMarkdown = require("@common/markdown/chatMessageMarkdown");
var _liveReview = require("@common/schemas/live-review");
var _materialSymbols = require("@design/icons/material-symbols");
var _react = _interopRequireWildcard(require("react"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _icertisLookupOptions = require("@common/utils/icertisLookupOptions");
var _CardPreviewsContext = require("../../components/chat/proposal-card/CardPreviewsContext");
var _chatPageMarkdown = require("../chat-page-markdown");
var _ChatPage = require("../ChatPage.styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "href"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t4 in e) "default" !== _t4 && {}.hasOwnProperty.call(e, _t4) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t4)) && (i.get || i.set) ? o(f, _t4, i) : f[_t4] = e[_t4]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var firstMessage = exports.firstMessage = {
  turnType: "assistant",
  content: "Hello! How can I help you today?"
};
var CITATION_MESSAGE_INDEX_UNASSIGNED = -1;
var MESSAGE_NOT_SHOWN_MESSAGE = exports.MESSAGE_NOT_SHOWN_MESSAGE = "This message could not be shown.";
var MESSAGE_NOT_SHOWN_FALLBACK = /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
  className: "text-[12px] text-[#B45309]",
  children: MESSAGE_NOT_SHOWN_MESSAGE
});
function lastAssistantTextIndex(messages) {
  for (var position = messages.length - 1; position >= 0; position -= 1) {
    var candidate = messages[position];
    if (candidate.turnType === "assistant" && (0, _chat.getMessageType)(candidate) === "text") return position;
  }
  return -1;
}
var convertToExtendedMessage = exports.convertToExtendedMessage = function convertToExtendedMessage(message) {
  function getMessageTimestamps(message) {
    var wireArtifacts = message.turnArtifacts;
    var skewProneDbCompletedAt = "completedAt" in message && message.completedAt ? message.completedAt : undefined;
    return {
      utcWireTimestamp: wireArtifacts === null || wireArtifacts === void 0 ? void 0 : wireArtifacts.timestamp,
      createdAt: "createdAt" in message && message.createdAt ? message.createdAt : undefined,
      completedAt: (wireArtifacts === null || wireArtifacts === void 0 ? void 0 : wireArtifacts.completed_at) || skewProneDbCompletedAt
    };
  }
  var turnType = "role" in message ? message.role === _webApi.Role.USER ? "user" : "assistant" : message.turnType;
  var chatMessage = {
    content: message.content,
    turnType: turnType,
    conversationId: "conversationId" in message ? message.conversationId : undefined,
    turnArtifacts: "turnArtifacts" in message ? message.turnArtifacts : {}
  };
  if ("id" in message) chatMessage.id = message.id;
  if ("propelAuthUserID" in message) chatMessage.propelAuthUserID = message.propelAuthUserID;
  var _getMessageTimestamps = getMessageTimestamps(message),
    utcWireTimestamp = _getMessageTimestamps.utcWireTimestamp,
    createdAt = _getMessageTimestamps.createdAt,
    completedAt = _getMessageTimestamps.completedAt;
  if (utcWireTimestamp) chatMessage.timestamp = utcWireTimestamp;
  if (createdAt) chatMessage.createdAt = createdAt;
  if (completedAt) chatMessage.completedAt = completedAt;
  if ("propelAuthOrgID" in message) chatMessage.propelAuthOrgID = message.propelAuthOrgID;
  if (chatMessage.turnArtifacts && _typeof(chatMessage.turnArtifacts) === "object") {
    var artifacts = chatMessage.turnArtifacts;
    if (artifacts.type === "tool_call" && artifacts.tool_name) {
      chatMessage.content = (0, _tools.getToolDisplayName)(artifacts.tool_name);
      chatMessage.messageType = "tool_call";
      chatMessage.toolName = artifacts.tool_name;
    } else if (artifacts.type === "tool_result") {
      chatMessage.messageType = "tool_result";
      chatMessage.toolName = artifacts.tool_name;
      if (artifacts.bookmarks && Array.isArray(artifacts.bookmarks)) {
        chatMessage.bookmarks = artifacts.bookmarks;
      }
      if (artifacts.citations && Array.isArray(artifacts.citations)) {
        chatMessage.citations = artifacts.citations.map(function (citation, index) {
          return {
            id: citation.id || "citation-".concat(index),
            number: citation.number,
            document_title: citation.document_title,
            cited_text: citation.cited_text,
            bookmark_start: citation.bookmark_start,
            bookmark_end: citation.bookmark_end,
            bookmarks: citation.bookmark_start && citation.bookmark_end ? [citation.bookmark_start, citation.bookmark_end] : undefined,
            messageIndex: CITATION_MESSAGE_INDEX_UNASSIGNED
          };
        });
      }
    }
  }
  if ("bookmarks" in message && Array.isArray(message.bookmarks)) {
    chatMessage.bookmarks = message.bookmarks;
  }
  if ("citations" in message && Array.isArray(message.citations)) {
    chatMessage.citations = message.citations.map(function (citation, index) {
      return {
        id: citation.id || "citation-".concat(index),
        number: citation.number,
        document_title: citation.document_title,
        cited_text: citation.cited_text,
        bookmark_start: citation.bookmark_start,
        bookmark_end: citation.bookmark_end,
        bookmarks: citation.bookmark_start && citation.bookmark_end ? [citation.bookmark_start, citation.bookmark_end] : undefined,
        messageIndex: CITATION_MESSAGE_INDEX_UNASSIGNED
      };
    });
  }
  return chatMessage;
};
var DOCUMENT_LINK_PREFIX = "/documents/";
var HIDDEN_SYSTEM_MESSAGE_PREFIX = "[SYSTEM_MESSAGE] ";
function anchorLiveReviewTimerStart(active, cached) {
  if (cached && cached.id === active.runId) return cached;
  var firstObservedFallbackMs = Date.now();
  return {
    id: active.runId,
    ms: Number.isNaN(active.startedAtMs) ? firstObservedFallbackMs : active.startedAtMs
  };
}
var REVERT_CHECKPOINT_TOOLTIP = "Restores the document exactly as it was at this point in the conversation, undoing every change applied after it.";
var REVERT_CHECKPOINT_TOOLTIP_DELAY_MS = 900;
var SCROLL_TARGET_HIGHLIGHT_COLOR = "#FFF9E6";
var VIRTUOSO_SCROLL_TARGET_RENDER_SETTLE_MS = 300;
var SCROLL_TARGET_HIGHLIGHT_DURATION_MS = 1500;
function renderArtifactThumbnailHeader(a) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: ["Saved ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
      className: "text-gray-900",
      children: a.name
    }), " to the Outputs panel."]
  });
}
function renderArtifactTableHeader(a) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
    className: "text-gray-900",
    "data-sentry-component": "renderArtifactTableHeader",
    "data-sentry-source-file": "use-message-list.tsx",
    children: a.name
  });
}
function renderSentFiles(turnArtifacts) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddinArtifactThumbnail.AddinSentFiles, {
    turnArtifacts: turnArtifacts,
    "data-sentry-element": "AddinSentFiles",
    "data-sentry-component": "renderSentFiles",
    "data-sentry-source-file": "use-message-list.tsx"
  });
}
function renderChatMarker(marker) {
  switch (marker.kind) {
    case "artifact-thumbnail":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddinArtifactThumbnail.AddinArtifactThumbnail, {
        artifactId: marker.id,
        renderHeader: renderArtifactThumbnailHeader
      });
    case "artifact-table":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddinArtifactThumbnail.AddinArtifactThumbnail, {
        artifactId: marker.id,
        renderHeader: renderArtifactTableHeader
      });
    case "scroll-to-form":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScrollToFormLink.ScrollToFormLink, {
        formId: marker.id
      });
    default:
      return marker.kind;
  }
}
function isHoistedResultCard(m) {
  var _m$turnArtifacts, _m$toolName, _m$turnArtifacts2;
  if (((_m$turnArtifacts = m.turnArtifacts) === null || _m$turnArtifacts === void 0 ? void 0 : _m$turnArtifacts.parent_tool_name) !== "sub_agent") return false;
  if (m.messageType !== "tool_result") return false;
  var toolName = (_m$toolName = m.toolName) !== null && _m$toolName !== void 0 ? _m$toolName : (_m$turnArtifacts2 = m.turnArtifacts) === null || _m$turnArtifacts2 === void 0 ? void 0 : _m$turnArtifacts2.tool_name;
  return !!toolName && _tools.HOISTED_SUBAGENT_RESULT_TOOLS.has(toolName);
}
var MessageRenderScopeContext = /*#__PURE__*/_react.default.createContext(null);
function useMessageRenderScope() {
  var scope = (0, _react.useContext)(MessageRenderScopeContext);
  if (!scope) throw new Error("Chat markdown rendered outside its message scope");
  return scope;
}
function citationNumberFor(scope, citationId) {
  var _scope$citationsById$;
  var known = (_scope$citationsById$ = scope.citationsById.get(citationId)) === null || _scope$citationsById$ === void 0 ? void 0 : _scope$citationsById$.number;
  if (known !== undefined) return known;
  var assigned = scope.citationNumbersById.get(citationId);
  if (assigned !== undefined) return assigned;
  var next = scope.citationNumbersById.size + 1;
  scope.citationNumbersById.set(citationId, next);
  return next;
}
var CITATION_BUTTON_STYLE = {
  display: "inline-block",
  verticalAlign: "baseline",
  margin: "0 2px"
};
var CITATION_BUTTON_TITLE = "Click to view cited section";
var EMBEDDED_CITATION_HREF_PREFIX = "#cite";
function stringAttribute(anchorProps, name) {
  var value = anchorProps[name];
  return typeof value === "string" ? value : undefined;
}
function renderCitationAnchor(scope, anchorProps) {
  var children = anchorProps.children,
    href = anchorProps.href,
    props = _objectWithoutProperties(anchorProps, _excluded);
  var startBlockId = stringAttribute(anchorProps, "data-cite-block-start");
  var endBlockId = stringAttribute(anchorProps, "data-cite-block-end");
  var documentTitle = stringAttribute(anchorProps, "data-cite-document-title");
  var bookmarkStart = stringAttribute(anchorProps, "bookmark_start") || stringAttribute(anchorProps, "bookmarkStart");
  var bookmarkEnd = stringAttribute(anchorProps, "bookmark_end") || stringAttribute(anchorProps, "bookmarkEnd");
  if (bookmarkStart && bookmarkEnd) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPage.BookmarkButton, {
      style: CITATION_BUTTON_STYLE,
      onClick: function onClick() {
        return scope.selectBookmarksRange([bookmarkStart, bookmarkEnd]);
      },
      title: CITATION_BUTTON_TITLE,
      children: children
    }, "citation-bookmark-".concat(scope.messageIndex, "-").concat(bookmarkStart, "-").concat(bookmarkEnd));
  }
  if (href && href.startsWith(EMBEDDED_CITATION_HREF_PREFIX)) {
    var citationId = href.replace(EMBEDDED_CITATION_HREF_PREFIX, "");
    var hrefBookmarkStart = stringAttribute(anchorProps, "bookmark_start");
    var hrefBookmarkEnd = stringAttribute(anchorProps, "bookmark_end");
    if (hrefBookmarkStart && hrefBookmarkEnd) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPage.BookmarkButton, {
        style: CITATION_BUTTON_STYLE,
        onClick: function onClick() {
          return scope.selectBookmarksRange([hrefBookmarkStart, hrefBookmarkEnd]);
        },
        title: CITATION_BUTTON_TITLE,
        children: citationNumberFor(scope, citationId)
      }, "citation-embedded-".concat(scope.messageIndex, "-").concat(citationId));
    }
    var citation = scope.citationsById.get(citationId);
    if (citation) {
      var bookmarks = citation.bookmarks || (citation.bookmark_start && citation.bookmark_end ? [citation.bookmark_start, citation.bookmark_end] : undefined);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPage.BookmarkButton, {
        style: CITATION_BUTTON_STYLE,
        onClick: function onClick() {
          return bookmarks && scope.selectBookmarksRange(bookmarks);
        },
        title: CITATION_BUTTON_TITLE,
        children: citation.number || (typeof citation.id === "number" ? citation.id : "1")
      }, "citation-fallback-".concat(scope.messageIndex, "-").concat(citationId));
    }
  }
  if (startBlockId && endBlockId && documentTitle !== undefined && (documentTitle == scope.documentName || documentTitle.replace(/_/g, " ") == scope.documentName.replace(/_/g, " "))) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("a", _objectSpread(_objectSpread({
      href: href
    }, props), {}, {
      onClick: function onClick(e) {
        e.preventDefault();
        scope.selectBookmarksRange([startBlockId, endBlockId]);
      },
      children: children
    }));
  }
  if (href !== null && href !== void 0 && href.startsWith(DOCUMENT_LINK_PREFIX)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentCitationAnchor.DocumentCitationAnchor, {
      href: href,
      inFocusDocumentId: scope.inFocusDocumentId,
      onSelectBookmarks: scope.selectBookmarksRange,
      children: children
    });
  }
  return null;
}
var AddinLink = function AddinLink(anchorProps) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPage.StyledLink, _objectSpread(_objectSpread({}, anchorProps), {}, {
    "data-sentry-element": "StyledLink",
    "data-sentry-component": "AddinLink",
    "data-sentry-source-file": "use-message-list.tsx"
  }));
};
function anchorSurfaceFor(scope) {
  return {
    renderMarker: renderChatMarker,
    renderCitation: function renderCitation(anchorProps) {
      return renderCitationAnchor(scope, anchorProps);
    },
    Link: AddinLink,
    openExternal: _openInBrowserWindow.openInBrowserWindow
  };
}
var ChatAnchor = function ChatAnchor(anchorProps) {
  var scope = useMessageRenderScope();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatAnchorRouter.ChatAnchorRouter, _objectSpread(_objectSpread({}, anchorProps), {}, {
    surface: anchorSurfaceFor(scope),
    "data-sentry-element": "ChatAnchorRouter",
    "data-sentry-component": "ChatAnchor",
    "data-sentry-source-file": "use-message-list.tsx"
  }));
};
var chatMarkdownComponents = _objectSpread(_objectSpread({
  a: ChatAnchor,
  ul: _chatPageMarkdown.MarkdownUnorderedList,
  ol: _chatPageMarkdown.MarkdownOrderedList,
  li: _chatPageMarkdown.MarkdownListItem,
  p: _chatPageMarkdown.MarkdownParagraph,
  span: _chatPageMarkdown.MarkdownSpan,
  blockquote: _sharedMarkdownComponents.sharedMarkdownComponents.blockquote,
  code: _sharedMarkdownComponents.sharedMarkdownComponents.code,
  pre: _sharedMarkdownComponents.sharedMarkdownComponents.pre,
  h1: _sharedMarkdownComponents.sharedMarkdownComponents.h1,
  h2: _sharedMarkdownComponents.sharedMarkdownComponents.h2,
  h3: _sharedMarkdownComponents.sharedMarkdownComponents.h3,
  h4: _sharedMarkdownComponents.sharedMarkdownComponents.h4
}, _sharedChatTableComponents.sharedChatTableComponents), {}, {
  table: _chatPageMarkdown.MarkdownTable
});
function useMessageList(_ref) {
  var isGenerating = _ref.isGenerating,
    webappFetch = _ref.webappFetch,
    selectBookmarksRange = _ref.selectBookmarksRange,
    selectBookmarksRangeIfPresent = _ref.selectBookmarksRangeIfPresent,
    documentName = _ref.documentName,
    inFocusFileRef = _ref.inFocusFileRef,
    setAutoScrollEnabled = _ref.setAutoScrollEnabled,
    toolStatusByCallId = _ref.toolStatusByCallId,
    sendError = _ref.sendError,
    documentBackups = _ref.documentBackups,
    revertDocumentToBackup = _ref.revertDocumentToBackup,
    conversationMatchesOpenDocument = _ref.conversationMatchesOpenDocument,
    restoringBackupName = _ref.restoringBackupName,
    isActionApplied = _ref.isActionApplied,
    isActionDismissed = _ref.isActionDismissed,
    isActionDismissalSaving = _ref.isActionDismissalSaving,
    markActionAsApplied = _ref.markActionAsApplied,
    recordActionFailure = _ref.recordActionFailure,
    markActionAsDismissed = _ref.markActionAsDismissed,
    markActionAsUndismissed = _ref.markActionAsUndismissed,
    getActionRecoveryWarning = _ref.getActionRecoveryWarning,
    getActionFailure = _ref.getActionFailure,
    markActionAsFailed = _ref.markActionAsFailed,
    markActionWithRecoveryWarning = _ref.markActionWithRecoveryWarning,
    regeneratingToolResults = _ref.regeneratingToolResults,
    regenerateMessageRedline = _ref.regenerateMessageRedline,
    showFeedbackFormForMessageId = _ref.showFeedbackFormForMessageId,
    setShowFeedbackFormForMessageId = _ref.setShowFeedbackFormForMessageId,
    handleSaveGuideline = _ref.handleSaveGuideline,
    handleDismissGuideline = _ref.handleDismissGuideline,
    handleSaveSkill = _ref.handleSaveSkill,
    handleDismissSkill = _ref.handleDismissSkill,
    handlePlaybookSelect = _ref.handlePlaybookSelect,
    handleCreateNewPlaybook = _ref.handleCreateNewPlaybook,
    handleSaveCollectInputAnswer = _ref.handleSaveCollectInputAnswer,
    handleSend = _ref.handleSend,
    handleOpenReview = _ref.handleOpenReview,
    handleCopyToClipboard = _ref.handleCopyToClipboard,
    handleSaveUserMessageAsPrompt = _ref.handleSaveUserMessageAsPrompt,
    copyClipboardIndicator = _ref.copyClipboardIndicator,
    savePromptIndicator = _ref.savePromptIndicator,
    messages = _ref.messages,
    filteredMessagesRef = _ref.filteredMessagesRef,
    virtuosoRef = _ref.virtuosoRef,
    conversationId = _ref.conversationId,
    cardNumbers = _ref.cardNumbers,
    potentialCollisionsByActionId = _ref.potentialCollisionsByActionId,
    cardPreviews = _ref.cardPreviews,
    getActionSupersession = _ref.getActionSupersession,
    getActionPartSupersession = _ref.getActionPartSupersession,
    regeneratingToolResultIds = _ref.regeneratingToolResultIds,
    revertedActionIds = _ref.revertedActionIds,
    partlyRevertedActionIds = _ref.partlyRevertedActionIds;
  var messageRefs = (0, _react.useRef)(new Map());
  var fetchLookupOptions = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(optionsUrl) {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _t = _icertisLookupOptions.icertisLookupOptionLabels;
            _context.n = 1;
            return webappFetch((0, _icertisLookupOptions.icertisLookupOptionsPath)(optionsUrl));
          case 1:
            return _context.a(2, _t(_context.v));
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [webappFetch]);
  var rateableMessageIds = (0, _react.useMemo)(function () {
    return (0, _rateableMessages.computeRateableMessageIds)(messages.map(function (message) {
      var _message$id;
      return {
        id: (_message$id = message.id) !== null && _message$id !== void 0 ? _message$id : "",
        turnType: message.turnType,
        messageType: (0, _chat.getMessageType)(message)
      };
    }), isGenerating);
  }, [messages, isGenerating]);
  var citations = (0, _react.useMemo)(function () {
    var allCitations = [];
    var maxId = 1;
    var messageCitations = [];
    var message_index = 0;
    messages.forEach(function (message) {
      var _message$turnArtifact, _message$turnArtifact2;
      var messageType = (0, _chat.getMessageType)(message);
      if (message.turnType === "assistant" && ((_message$turnArtifact = message.turnArtifacts) === null || _message$turnArtifact === void 0 ? void 0 : _message$turnArtifact.type) === "tool_call" && ((_message$turnArtifact2 = message.turnArtifacts) === null || _message$turnArtifact2 === void 0 ? void 0 : _message$turnArtifact2.tool_name) === "") {
        return;
      }
      if (message.turnType === "assistant" && messageType === "text") {
        var _citations = (0, _chatCitations.extractCitationsFromContent)(message.content);
        if (_citations.length > 0) {
          messageCitations.push({
            messageIndex: message_index,
            citations: _citations.map(function (c) {
              return _objectSpread(_objectSpread({}, c), {}, {
                id: maxId + (typeof c.id === 'number' ? c.id : 0) - 1
              });
            })
          });
          maxId += _citations.length;
        }
      }
      if (message.turnType === "assistant" && messageType === "tool_result") {
        if (message.citations && Array.isArray(message.citations)) {
          messageCitations.push({
            messageIndex: message_index,
            citations: message.citations.map(function (citation) {
              return _objectSpread(_objectSpread({}, citation), {}, {
                messageIndex: CITATION_MESSAGE_INDEX_UNASSIGNED
              });
            })
          });
        }
      }
      message_index++;
    });
    messageCitations.forEach(function (_ref3) {
      var messageIndex = _ref3.messageIndex,
        citations = _ref3.citations;
      citations.forEach(function (citation) {
        citation.messageIndex = messageIndex;
        allCitations.push(citation);
      });
    });
    return allCitations;
  }, [messages]);
  var renderMessageContent = (0, _react.useCallback)(function (content, messageIndex, citations, message) {
    var _inFocusFileRef$curre, _inFocusFileRef$curre2;
    var messageCitations = (message === null || message === void 0 ? void 0 : message.citations) || citations.filter(function (c) {
      return c.messageIndex === messageIndex;
    });
    var scope = {
      messageIndex: messageIndex,
      citationsById: new Map(messageCitations.map(function (c) {
        return [String(c.id), c];
      })),
      citationNumbersById: new Map(),
      documentName: documentName,
      inFocusDocumentId: (_inFocusFileRef$curre = (_inFocusFileRef$curre2 = inFocusFileRef.current) === null || _inFocusFileRef$curre2 === void 0 ? void 0 : _inFocusFileRef$curre2.id) !== null && _inFocusFileRef$curre !== void 0 ? _inFocusFileRef$curre : null,
      selectBookmarksRange: selectBookmarksRange,
      webappFetch: webappFetch
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(MessageRenderScopeContext.Provider, {
      value: scope,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactMarkdown.default, {
        components: chatMarkdownComponents,
        rehypePlugins: _chatMarkdownPipeline.chatRehypePlugins,
        remarkPlugins: (0, _chatMessageMarkdown.chatRemarkPluginsFor)((message === null || message === void 0 ? void 0 : message.turnType) === "user" ? "user" : "assistant"),
        children: content
      })
    });
  }, [selectBookmarksRange, documentName, webappFetch]);
  var scrollToMessageIndex = (0, _react.useCallback)(function (index, actionId) {
    var _virtuosoRef$current;
    setAutoScrollEnabled(false);
    (_virtuosoRef$current = virtuosoRef.current) === null || _virtuosoRef$current === void 0 || _virtuosoRef$current.scrollToIndex({
      index: index,
      align: "start",
      behavior: "smooth"
    });
    setTimeout(function () {
      var el = messageRefs.current.get(actionId);
      if (el) {
        el.style.backgroundColor = SCROLL_TARGET_HIGHLIGHT_COLOR;
        setTimeout(function () {
          el.style.backgroundColor = "";
        }, SCROLL_TARGET_HIGHLIGHT_DURATION_MS);
      }
    }, VIRTUOSO_SCROLL_TARGET_RENDER_SETTLE_MS);
  }, [setAutoScrollEnabled, virtuosoRef]);
  var handleScrollToAction = (0, _react.useCallback)(function (actionId) {
    var index = filteredMessagesRef.current.findIndex(function (message, i) {
      return (0, _chat.getActionIdentifier)(message, "msg-".concat(i)) === actionId;
    });
    if (index === -1) return;
    scrollToMessageIndex(index, actionId);
  }, [scrollToMessageIndex, filteredMessagesRef]);
  var handleScrollToLiveReview = (0, _react.useCallback)(function (reviewId, actionId) {
    var index = filteredMessagesRef.current.findIndex(function (message) {
      var data = (0, _liveReview.parseLiveReviewMessage)(message);
      return !!data && !!data.reviewId && data.reviewId === reviewId;
    });
    if (index === -1) {
      handleScrollToAction(actionId);
      return;
    }
    var message = filteredMessagesRef.current[index];
    scrollToMessageIndex(index, (0, _chat.getActionIdentifier)(message, "msg-".concat(index)));
  }, [handleScrollToAction, scrollToMessageIndex, filteredMessagesRef]);
  var filteredMessages = (0, _react.useMemo)(function () {
    function isEmptyContentRowTheStepGrouperNeeds(message) {
      var _message$turnArtifact3, _message$turnArtifact4, _message$turnArtifact5;
      if ((_message$turnArtifact3 = message.turnArtifacts) !== null && _message$turnArtifact3 !== void 0 && _message$turnArtifact3.parent_tool_call_id) return true;
      if (((_message$turnArtifact4 = message.turnArtifacts) === null || _message$turnArtifact4 === void 0 ? void 0 : _message$turnArtifact4.type) === "interrupted") return true;
      return ((_message$turnArtifact5 = message.turnArtifacts) === null || _message$turnArtifact5 === void 0 ? void 0 : _message$turnArtifact5.type) === "tool_status";
    }
    function mergeToolGroupsPerTurn(messages) {
      var out = [];
      var i = 0;
      while (i < messages.length) {
        var _toolGroups$0$turnArt;
        if (messages[i].turnType === "user") {
          out.push(messages[i++]);
          continue;
        }
        var turnStart = i;
        while (i < messages.length && messages[i].turnType !== "user") i++;
        var turn = messages.slice(turnStart, i);
        var hoistedResultCardsForTurn = turn.filter(isHoistedResultCard);
        var turnBeforeHoistedResultCards = hoistedResultCardsForTurn.length ? turn.filter(function (m) {
          return !isHoistedResultCard(m);
        }) : turn;
        var toolGroups = turnBeforeHoistedResultCards.filter(function (m) {
          return m.messageType === _groupAssistantSteps.TOOL_GROUP_MESSAGE_TYPE;
        });
        if (toolGroups.length <= 1) {
          out.push.apply(out, _toConsumableArray(turnBeforeHoistedResultCards).concat(_toConsumableArray(hoistedResultCardsForTurn)));
          continue;
        }
        var allSteps = toolGroups.flatMap(function (g) {
          return (0, _groupAssistantSteps.toolGroupSteps)(g);
        });
        var isStreaming = toolGroups.some(function (g) {
          return (0, _groupAssistantSteps.isToolGroupStreaming)(g);
        });
        var mergedGroup = _objectSpread(_objectSpread({}, toolGroups[0]), {}, {
          turnArtifacts: _objectSpread(_objectSpread({}, (_toolGroups$0$turnArt = toolGroups[0].turnArtifacts) !== null && _toolGroups$0$turnArt !== void 0 ? _toolGroups$0$turnArt : {}), {}, {
            type: _groupAssistantSteps.TOOL_GROUP_MESSAGE_TYPE,
            steps: allSteps,
            isStreaming: isStreaming
          })
        });
        var firstToolGroupPosition = turnBeforeHoistedResultCards.findIndex(function (m) {
          return m.messageType === _groupAssistantSteps.TOOL_GROUP_MESSAGE_TYPE;
        });
        var nonToolGroupsBefore = turnBeforeHoistedResultCards.slice(0, firstToolGroupPosition);
        var nonToolGroupsAfter = turnBeforeHoistedResultCards.slice(firstToolGroupPosition).filter(function (m) {
          return m.messageType !== _groupAssistantSteps.TOOL_GROUP_MESSAGE_TYPE;
        });
        out.push.apply(out, _toConsumableArray(nonToolGroupsBefore).concat([mergedGroup], _toConsumableArray(nonToolGroupsAfter), _toConsumableArray(hoistedResultCardsForTurn)));
      }
      return out;
    }
    var filtered = messages.filter(function (m) {
      var mt = (0, _chat.getMessageType)(m);
      if (mt === "tool_call" || mt === "tool_result") return true;
      if (m.content && m.content.startsWith(HIDDEN_SYSTEM_MESSAGE_PREFIX) && m.turnType === "user") {
        return false;
      }
      if (m.content) return true;
      return isEmptyContentRowTheStepGrouperNeeds(m);
    });
    var grouped = (0, _groupAssistantSteps.groupAssistantSteps)(filtered, toolStatusByCallId);
    return mergeToolGroupsPerTurn(grouped);
  }, [messages, toolStatusByCallId]);
  var activeLiveReview = (0, _react.useMemo)(function () {
    function getLiveReviewStartMs(data, message) {
      var _message$turnArtifact6;
      var perRunBackendStart = data.runStartedAt;
      var startedIso = perRunBackendStart || ((_message$turnArtifact6 = message.turnArtifacts) === null || _message$turnArtifact6 === void 0 ? void 0 : _message$turnArtifact6.started_at) || message.timestamp;
      return startedIso ? Date.parse(startedIso) : NaN;
    }
    for (var i = filteredMessages.length - 1; i >= 0; i--) {
      var _data$runStartedAt;
      var m = filteredMessages[i];
      var data = (0, _liveReview.parseLiveReviewMessage)(m);
      if (!data) continue;
      var _getLiveReviewRulePro = (0, _liveReview.getLiveReviewRuleProgress)(data),
        checked = _getLiveReviewRulePro.checked,
        total = _getLiveReviewRulePro.total;
      return {
        actionId: (0, _chat.getActionIdentifier)(m, "msg-".concat(i)),
        runId: data.reviewId || (0, _chat.getActionIdentifier)(m, "msg-".concat(i)),
        runKey: "".concat(data.reviewId || (0, _chat.getActionIdentifier)(m, "msg-".concat(i)), ":").concat((_data$runStartedAt = data.runStartedAt) !== null && _data$runStartedAt !== void 0 ? _data$runStartedAt : ""),
        status: data.status,
        playbookName: data.playbookName || "Playbook Review",
        checkedRules: checked,
        totalRules: total,
        startedAtMs: getLiveReviewStartMs(data, m)
      };
    }
    return null;
  }, [filteredMessages]);
  var watchedLiveReviewRunKeyRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    dismissedLiveReviewRunKey = _useState2[0],
    setDismissedLiveReviewRunKey = _useState2[1];
  (0, _react.useEffect)(function () {
    if ((activeLiveReview === null || activeLiveReview === void 0 ? void 0 : activeLiveReview.status) === "running") {
      watchedLiveReviewRunKeyRef.current = activeLiveReview.runKey;
    }
  }, [activeLiveReview === null || activeLiveReview === void 0 ? void 0 : activeLiveReview.status, activeLiveReview === null || activeLiveReview === void 0 ? void 0 : activeLiveReview.runKey]);
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    liveReviewTimerAnchor = _useState4[0],
    setLiveReviewTimerAnchor = _useState4[1];
  (0, _react.useEffect)(function () {
    setLiveReviewTimerAnchor(function (cached) {
      return (activeLiveReview === null || activeLiveReview === void 0 ? void 0 : activeLiveReview.status) === "running" ? anchorLiveReviewTimerStart(activeLiveReview, cached) : null;
    });
  }, [activeLiveReview]);
  var showLiveReviewBar = !!activeLiveReview && (activeLiveReview.status === "running" || watchedLiveReviewRunKeyRef.current === activeLiveReview.runKey && dismissedLiveReviewRunKey !== activeLiveReview.runKey);
  var liveReviewStartMs = activeLiveReview ? anchorLiveReviewTimerStart(activeLiveReview, liveReviewTimerAnchor).ms : 0;
  var handleDownloadMessageAsDocx = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(content) {
      var _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            _context2.n = 1;
            return (0, _document.downloadMessageAsDocx)(content);
          case 1:
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t2 = _context2.v;
            (0, _toast.toastError)(_t2);
            sendError(_t2 instanceof Error ? _t2 : new Error(String(_t2)), {
              component: 'ChatPage',
              action: 'download_message_as_docx'
            });
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }));
    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [sendError]);
  var computeItemKey = (0, _react.useCallback)(function (index) {
    var _message$turnArtifact7;
    var message = filteredMessagesRef.current[index];
    if (!message) return "msg-".concat(index);
    var messageType = (0, _chat.getMessageType)(message);
    var actionId = (0, _chat.getActionIdentifier)(message, "msg-".concat(index));
    var artifactType = typeof ((_message$turnArtifact7 = message.turnArtifacts) === null || _message$turnArtifact7 === void 0 ? void 0 : _message$turnArtifact7.type) === "string" && message.turnArtifacts.type.trim() ? message.turnArtifacts.type.trim() : undefined;
    var keySuffix = artifactType || (messageType !== "text" ? messageType : undefined);
    return keySuffix ? "".concat(actionId, "-").concat(keySuffix) : actionId;
  }, [filteredMessages, filteredMessagesRef]);
  var backupsBySlotKey = (0, _react.useMemo)(function () {
    var rows = filteredMessages.map(function (message, index) {
      return {
        id: (0, _chat.getActionIdentifier)(message, "msg-".concat(index)),
        messageId: message.id,
        turnType: message.turnType,
        toolName: message.toolName,
        timestamp: message.timestamp,
        createdAt: message.createdAt,
        steps: (0, _groupAssistantSteps.toolGroupSteps)(message)
      };
    });
    return (0, _documentBackupPlacement.resolveBackupPlacements)(documentBackups, rows);
  }, [documentBackups, filteredMessages]);
  var handleRevertDocument = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(backup) {
      var _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            _context3.n = 1;
            return revertDocumentToBackup(backup);
          case 1:
            _context3.n = 3;
            break;
          case 2:
            _context3.p = 2;
            _t3 = _context3.v;
            sendError(_t3 instanceof Error ? _t3 : new Error(String(_t3)), {
              component: "ChatPage",
              action: "revert_document_to_backup",
              conversationId: conversationId
            });
          case 3:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 2]]);
    }));
    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }(), [revertDocumentToBackup, sendError, conversationId]);
  var renderRestoreChip = (0, _react.useCallback)(function (slotKey) {
    if (!conversationMatchesOpenDocument) return null;
    var backup = backupsBySlotKey.get(slotKey);
    if (!backup) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex justify-end items-center gap-1.5 pr-2 my-1",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_hoverTooltip.HoverTooltip, {
        content: REVERT_CHECKPOINT_TOOLTIP,
        align: "start",
        focusable: false,
        delayDuration: REVERT_CHECKPOINT_TOOLTIP_DELAY_MS,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          type: "button",
          onClick: function onClick() {
            return handleRevertDocument(backup);
          },
          disabled: restoringBackupName !== null,
          className: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-gray-50 border border-gray-300 text-xs font-medium text-gray-600 hover:bg-gray-100 disabled:opacity-50",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.UndoIcon, {
            width: 12,
            height: 12
          }), restoringBackupName === backup.name ? "Restoring…" : "Restore document to here"]
        })
      })
    });
  }, [conversationMatchesOpenDocument, backupsBySlotKey, handleRevertDocument, restoringBackupName]);
  var renderStepRestoreChip = (0, _react.useCallback)(function (toolCallId) {
    return renderRestoreChip((0, _documentBackupPlacement.stepSlotKey)(toolCallId));
  }, [renderRestoreChip]);
  var renderMessage = (0, _react.useCallback)(function (index) {
    var _getActionFailure$con, _getActionFailure, _potentialCollisionsB;
    var message = filteredMessagesRef.current[index];
    if (!message) return null;
    var isStreamingText = isGenerating && index === lastAssistantTextIndex(filteredMessagesRef.current);
    var actionId = (0, _chat.getActionIdentifier)(message, "msg-".concat(index));
    var rateable = !!message.id && rateableMessageIds.has(message.id);
    var conflictingCards = ((_getActionFailure$con = (_getActionFailure = getActionFailure(conversationId, actionId)) === null || _getActionFailure === void 0 ? void 0 : _getActionFailure.conflictingActionIds) !== null && _getActionFailure$con !== void 0 ? _getActionFailure$con : []).flatMap(function (conflictingActionId) {
      var number = cardNumbers.get(conflictingActionId);
      return number === undefined ? [] : [{
        id: conflictingActionId,
        label: "#".concat(number),
        onShow: function onShow() {
          return handleScrollToAction(conflictingActionId);
        }
      }];
    });
    var potentialCollisions = ((_potentialCollisionsB = potentialCollisionsByActionId.get(actionId)) !== null && _potentialCollisionsB !== void 0 ? _potentialCollisionsB : []).flatMap(function (collision) {
      var number = cardNumbers.get(collision.otherCardId);
      return number === undefined ? [] : [{
        number: number,
        proximity: collision.proximity,
        alsoMakesSameChange: collision.alsoMakesSameChange,
        otherChange: (0, _CardPreviewsContext.otherCardChangeOf)(cardPreviews, collision.otherCardId),
        onShow: function onShow() {
          return handleScrollToAction(collision.otherCardId);
        }
      }];
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      ref: function ref(el) {
        if (el && (0, _chat.isApplicableActionMessage)(message)) {
          messageRefs.current.set(actionId, el);
        } else if (!el) {
          messageRefs.current.delete(actionId);
        }
      },
      children: [renderRestoreChip((0, _documentBackupPlacement.rowSlotKey)(actionId)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionBoundary.SectionBoundary, {
        section: "chat_message",
        cardActionIds: [actionId],
        resetKeys: [message.content],
        fallback: MESSAGE_NOT_SHOWN_FALLBACK,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.default, {
          message: message,
          index: index,
          actionId: actionId,
          isStreaming: isGenerating,
          isStreamingText: isStreamingText,
          isLastMessage: index === filteredMessagesRef.current.length - 1,
          rateable: rateable,
          citations: citations,
          selectedConversationId: conversationId,
          documentName: documentName,
          isActionApplied: isActionApplied,
          isActionDismissed: isActionDismissed,
          isActionDismissalSaving: isActionDismissalSaving,
          markActionAsApplied: markActionAsApplied,
          recordActionFailure: recordActionFailure,
          markActionAsDismissed: markActionAsDismissed,
          markActionAsUndismissed: markActionAsUndismissed,
          getActionRecoveryWarning: getActionRecoveryWarning,
          getActionFailure: getActionFailure,
          markActionAsFailed: markActionAsFailed,
          cardNumber: cardNumbers.get(actionId),
          conflictingCards: conflictingCards,
          supersededBy: getActionSupersession(conversationId, actionId),
          revertedInDocument: revertedActionIds.has(actionId),
          partlyRevertedInDocument: partlyRevertedActionIds.has(actionId),
          partSupersededBy: getActionPartSupersession(conversationId, actionId),
          potentialCollisions: potentialCollisions,
          markActionWithRecoveryWarning: markActionWithRecoveryWarning,
          selectBookmarksRange: selectBookmarksRange,
          selectBookmarksRangeIfPresent: selectBookmarksRangeIfPresent,
          regeneratingToolResults: regeneratingToolResults,
          regenerateMessageRedline: regenerateMessageRedline,
          showFeedbackFormForMessageId: showFeedbackFormForMessageId,
          setShowFeedbackFormForMessageId: setShowFeedbackFormForMessageId,
          handleSaveGuideline: handleSaveGuideline,
          handleDismissGuideline: handleDismissGuideline,
          handleSaveSkill: handleSaveSkill,
          handleDismissSkill: handleDismissSkill,
          handlePlaybookSelect: handlePlaybookSelect,
          handleCreateNewPlaybook: handleCreateNewPlaybook,
          handleSaveCollectInputAnswer: handleSaveCollectInputAnswer,
          fetchLookupOptions: fetchLookupOptions,
          sendMessage: handleSend,
          handleOpenReview: handleOpenReview,
          sendError: sendError,
          renderMessageContent: renderMessageContent,
          renderSentFiles: renderSentFiles,
          handleCopyToClipboard: handleCopyToClipboard,
          handleSaveUserMessageAsPrompt: handleSaveUserMessageAsPrompt,
          handleDownloadMessageAsDocx: handleDownloadMessageAsDocx,
          copyClipboardIndicator: copyClipboardIndicator,
          savePromptIndicator: savePromptIndicator,
          renderStepRestoreChip: renderStepRestoreChip
        })
      })]
    });
  }, [renderRestoreChip, renderStepRestoreChip, filteredMessages, citations, conversationId, documentName, isActionApplied, isActionDismissed, isActionDismissalSaving, markActionAsApplied, recordActionFailure, markActionAsDismissed, markActionAsUndismissed, getActionRecoveryWarning, getActionFailure, getActionSupersession, getActionPartSupersession, markActionAsFailed, cardNumbers, potentialCollisionsByActionId, cardPreviews, revertedActionIds, partlyRevertedActionIds, handleScrollToAction, markActionWithRecoveryWarning, selectBookmarksRange, selectBookmarksRangeIfPresent, regeneratingToolResultIds, regenerateMessageRedline, showFeedbackFormForMessageId, handleSaveGuideline, handleDismissGuideline, handleSaveSkill, handleDismissSkill, handlePlaybookSelect, handleCreateNewPlaybook, handleSaveCollectInputAnswer, fetchLookupOptions, handleSend, handleOpenReview, sendError, renderMessageContent, handleCopyToClipboard, handleSaveUserMessageAsPrompt, handleDownloadMessageAsDocx, copyClipboardIndicator, savePromptIndicator, isGenerating, rateableMessageIds, setShowFeedbackFormForMessageId, filteredMessagesRef]);
  return {
    filteredMessages: filteredMessages,
    activeLiveReview: activeLiveReview,
    showLiveReviewBar: showLiveReviewBar,
    liveReviewStartMs: liveReviewStartMs,
    setDismissedLiveReviewRunKey: setDismissedLiveReviewRunKey,
    handleScrollToAction: handleScrollToAction,
    handleScrollToLiveReview: handleScrollToLiveReview,
    computeItemKey: computeItemKey,
    renderMessage: renderMessage
  };
}